import { ReactComponent as KnivesAndForkSvg } from '../../assets/icons/knives-and-fork.svg';

export const KnivesAndForkIcon: SvgIcon = (props) => {
    return <KnivesAndForkSvg {...props} />;
};
